import { ProfilePageConfig } from "./profile/ProfilePageConfig";

const moduleConfig = [ProfilePageConfig];

export default moduleConfig;
